module.exports = __webpack_public_path__ + "img/logo-genesis-2x.30dfcbac.png";